import React from 'react';
import PageHelmet from '../Helper/PageHelmet';
import Header from '../Helper/Header';
import Footer from '../Helper/Footer';

import HeroSection from './HeroSection';
import ChoiceSection from './ChoiceSection';
import PlanSection from './PlanSection';
import DocumentSection from './DocumentSection';
import AssuranceSection from './AssuranceSection';
import ProcessSection from './ProcessSection';
import ClientSection from './ClientSection';
import TestimonialSection from './TestimonialSection';
import ContactSection from './ContactSection';

const Home = () => {
    return (
        <>
            <PageHelmet pageTitle="Premisin Virtual Office - Get Virtual Office Space in Raipur" />
            <Header />
            <HeroSection />
            <ChoiceSection />
            <PlanSection />
            <DocumentSection />
            <AssuranceSection />
            <ProcessSection />
            <ClientSection />
            <TestimonialSection />
            <ContactSection />
            <Footer />
        </>
    );
};

export default Home;